import { useAppContext } from '@context/AppContext';
import { useEffect, useState } from 'react';

function useOwnership(profileId: number, role: 'employer' | 'student') {
  const [isOwner, setIsOwner] = useState(false);
  const { isAuthenticated, profile, userRole } = useAppContext();

  useEffect(() => {
    if (!isAuthenticated) {
      return setIsOwner(false);
    }

    if (role !== userRole) {
      return setIsOwner(false);
    }

    if (profileId === profile[`${role}Profile`]?.id) {
      return setIsOwner(true);
    }

    return setIsOwner(false);
  }, [profileId, isAuthenticated, role, userRole, profile]);

  return { isOwner };
}

export default useOwnership;
